module.exports = __webpack_public_path__ + "img/utilities.23cf93b2.svg";